<div>
  <h3>
    {{ label }}
  </h3>
  <form [formGroup]="dateForm">
    <div class="date-wrapper">
      <markant-datepicker
        #start
        id="start"
        type="date"
        dateFormat="d.m.Y"
        [formControlName]="'startDate'"
        [label]="'common.from' | transloco"
        (valueChange)="selectDate($event, idStart)"
      >
      </markant-datepicker>
      <markant-datepicker
        #end
        id="end"
        type="date"
        dateFormat="d.m.Y"
        [formControlName]="'endDate'"
        [label]="'common.until' | transloco"
        (valueChange)="selectDate($event, idEnd)"
      >
      </markant-datepicker>
    </div>
    <div
      class="validation-error-message"
      *ngIf="dateForm.hasError('startDateBeforeEndDate')"
    >
      <span>{{ 'usageRight.intervalInvalid' | transloco }}</span>
    </div>
  </form>
</div>
